module.exports = __webpack_public_path__ + "img/checkmark-square_fill.707fe858.svg";